import * as XLSX from "xlsx";

export default function CreateExcelForSymbrio(array: any) {
    const date = new Date();
    const wb = XLSX.utils.book_new();

    const emptyArray2: any = [
        ["Artikkelnummer", "Antall"]
    ];

    const aggregatedData: { [key: string]: { name: string; amount: number; date: string } } = {};

    for (let i = 0; i < array.length; i++) {
        const articleNumber = array[i].product.article_number;
        const productName = array[i].product.name;
        const amount = array[i].amount;
        const dateOrdered = new Date(
            array[i].timestamp.seconds * 1000 + array[i].timestamp.nanoseconds / 1000000
        ).toLocaleDateString();

        if (aggregatedData[articleNumber]) {
            aggregatedData[articleNumber].amount += amount;
        } else {
            aggregatedData[articleNumber] = {
                name: productName,
                amount: amount,
                date: dateOrdered
            };
        }
    }

    for (const articleNumber in aggregatedData) {
        emptyArray2.push([
            articleNumber,
            aggregatedData[articleNumber].amount
        ]);
    }

    const ws2 = XLSX.utils.aoa_to_sheet(emptyArray2);
    XLSX.utils.book_append_sheet(wb, ws2, `SymbrioImportering`, true);

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    const filename = `SymbrioImport_${date.toLocaleDateString([], { day: '2-digit', month: '2-digit', year: '2-digit' })}_${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}.xlsx`;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}